import React from 'react';
import { PageHero } from '../components/PageHero';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { MessageSquareIcon, PhoneIcon, MailIcon, MapPinIcon, PrinterIcon, SendIcon, ClockIcon } from 'lucide-react';
export function ContactPage() {
  useScrollReveal();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for your inquiry. Our team will contact you shortly.');
  };
  return <main className="w-full" data-id="element-174">
      <PageHero title="Let's Discuss Your Next Project" subtitle="Whether you need event production support, AV equipment, staging, lighting, or a custom solution, our team is ready to assist." icon={MessageSquareIcon} data-id="element-175" />

      <section className="py-20 px-6 bg-brand-black" data-id="element-176">
        <div className="max-w-7xl mx-auto" data-id="element-177">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-178">
            {/* Contact Form */}
            <div className="lg:col-span-3 reveal" data-id="element-179">
              <div className="glass-card p-8 md:p-10" data-id="element-180">
                <h2 className="text-2xl font-bold text-white mb-8" data-id="element-181">
                  Send us a message
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-182">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-183">
                    <div className="space-y-2" data-id="element-184">
                      <label htmlFor="name" className="text-sm font-medium text-brand-muted-light" data-id="element-185">
                        Full Name
                      </label>
                      <input type="text" id="name" required className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors" placeholder="John Doe" data-id="element-186" />
                    </div>
                    <div className="space-y-2" data-id="element-187">
                      <label htmlFor="email" className="text-sm font-medium text-brand-muted-light" data-id="element-188">
                        Email Address
                      </label>
                      <input type="email" id="email" required className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors" placeholder="john@example.com" data-id="element-189" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-190">
                    <div className="space-y-2" data-id="element-191">
                      <label htmlFor="phone" className="text-sm font-medium text-brand-muted-light" data-id="element-192">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors" placeholder="+267 123 4567" data-id="element-193" />
                    </div>
                    <div className="space-y-2" data-id="element-194">
                      <label htmlFor="company" className="text-sm font-medium text-brand-muted-light" data-id="element-195">
                        Company / Organization
                      </label>
                      <input type="text" id="company" className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors" placeholder="Your Company" data-id="element-196" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-197">
                    <div className="space-y-2" data-id="element-198">
                      <label htmlFor="eventType" className="text-sm font-medium text-brand-muted-light" data-id="element-199">
                        Event Type / Service Needed
                      </label>
                      <select id="eventType" className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors appearance-none" data-id="element-200">
                        <option value="" data-id="element-201">Select an option...</option>
                        <option value="corporate" data-id="element-202">Corporate Event</option>
                        <option value="concert" data-id="element-203">
                          Live Concert / Entertainment
                        </option>
                        <option value="wedding" data-id="element-204">Wedding / Private Event</option>
                        <option value="equipment" data-id="element-205">Equipment Rental Only</option>
                        <option value="installation" data-id="element-206">
                          Permanent Installation
                        </option>
                        <option value="other" data-id="element-207">Other</option>
                      </select>
                    </div>
                    <div className="space-y-2" data-id="element-208">
                      <label htmlFor="date" className="text-sm font-medium text-brand-muted-light" data-id="element-209">
                        Event Date (if applicable)
                      </label>
                      <input type="date" id="date" className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors" data-id="element-210" />
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-211">
                    <label htmlFor="message" className="text-sm font-medium text-brand-muted-light" data-id="element-212">
                      Project Details
                    </label>
                    <textarea id="message" rows={5} required className="w-full bg-brand-charcoal border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors resize-none" placeholder="Tell us about your requirements..." data-id="element-213"></textarea>
                  </div>

                  <button type="submit" className="btn-glow w-full md:w-auto flex items-center justify-center gap-2" data-id="element-214">
                    <SendIcon className="w-4 h-4" data-id="element-215" />
                    Send Message
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Details */}
            <div className="lg:col-span-2 space-y-6 reveal" style={{
            transitionDelay: '200ms'
          }} data-id="element-216">
              <div className="glass-card p-8 border-brand-blue/30 bg-brand-blue/5" data-id="element-217">
                <div className="flex items-center gap-4 mb-4" data-id="element-218">
                  <ClockIcon className="w-6 h-6 text-brand-cyan" data-id="element-219" />
                  <h3 className="text-lg font-bold text-white" data-id="element-220">
                    Quick Response
                  </h3>
                </div>
                <p className="text-brand-muted-light" data-id="element-221">
                  We typically respond to all inquiries within 24 hours during
                  business days.
                </p>
              </div>

              <div className="glass-card p-8 space-y-8" data-id="element-222">
                <div className="flex items-start gap-4" data-id="element-223">
                  <div className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center shrink-0 border border-white/5" data-id="element-224">
                    <PhoneIcon className="w-5 h-5 text-brand-blue" data-id="element-225" />
                  </div>
                  <div data-id="element-226">
                    <h4 className="text-white font-medium mb-1" data-id="element-227">Call Us</h4>
                    <a href="tel:+2673928692" className="text-brand-muted-light hover:text-brand-blue transition-colors block text-lg" data-id="element-228">
                      (+267) 3928692
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-229">
                  <div className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center shrink-0 border border-white/5" data-id="element-230">
                    <PrinterIcon className="w-5 h-5 text-brand-blue" data-id="element-231" />
                  </div>
                  <div data-id="element-232">
                    <h4 className="text-white font-medium mb-1" data-id="element-233">Fax</h4>
                    <span className="text-brand-muted-light block text-lg" data-id="element-234">
                      (+267) 3928169
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-235">
                  <div className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center shrink-0 border border-white/5" data-id="element-236">
                    <MailIcon className="w-5 h-5 text-brand-blue" data-id="element-237" />
                  </div>
                  <div data-id="element-238">
                    <h4 className="text-white font-medium mb-1" data-id="element-239">Email</h4>
                    <a href="mailto:info@audiotech.co.bw" className="text-brand-muted-light hover:text-brand-blue transition-colors block text-lg" data-id="element-240">
                      info@audiotech.co.bw
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-241">
                  <div className="w-12 h-12 rounded-full bg-brand-charcoal flex items-center justify-center shrink-0 border border-white/5" data-id="element-242">
                    <MapPinIcon className="w-5 h-5 text-brand-blue" data-id="element-243" />
                  </div>
                  <div data-id="element-244">
                    <h4 className="text-white font-medium mb-1" data-id="element-245">Location</h4>
                    <span className="text-brand-muted-light block text-lg" data-id="element-246">
                      Gaborone, Botswana
                    </span>
                  </div>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="img-placeholder h-48 w-full shadow-glass" data-id="element-247">
                <div className="text-center" data-id="element-248">
                  <MapPinIcon className="w-8 h-8 text-white/20 mx-auto mb-2" data-id="element-249" />
                  <span className="text-white/40 text-sm font-medium" data-id="element-250">
                    Interactive Map Placeholder
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>;
}